import { Component } from 'react';
import fEMR_logo from '../resources/fEMR_logo.png';
import "./NavbarStyle.css";
import { BsCardList } from 'react-icons/bs';
import { IoIosNotificationsOutline } from 'react-icons/io';
import { MdOutlineLeaderboard } from 'react-icons/md';
import { BiWorld } from 'react-icons/bi';
import { RiTeamLine } from 'react-icons/ri';
import { RxPerson } from 'react-icons/rx';
import { BiUserCircle } from 'react-icons/bi';
import { Badge } from '@mui/material';
import { FiLogOut } from 'react-icons/fi';


class Navbar extends Component {

    state={clicked: false};

    /* Function that toggles between the list icon and x icon.
    When the list icon is clicked on, the navbar links display
    in a right side container and the list icon becomes an x icon.
    When the x icon is clicked on, the right side container disappears
    and the x icon becomes the list icon.
    */

    /* TO DO: 
        * Add functionality to Notifications blue badge to only appear
          if the user has new unread notifications.
    */

    handleClick = () => {
        this.setState({clicked: !this.state.clicked})
    }

    render() {
        
        const handleLogout = () => {
            localStorage.removeItem('userInfo');
          };

        return (
            <nav> 
                <img className="logo" src={fEMR_logo} alt = ""/>
                <div>
                    <ul id="navbar" 
                    className={this.state.clicked ? "#navbar active" : "#navbar"}
                    >
                       <li><a href="/"><BsCardList/><i></i> Encounter</a></li>
                        <li><a href="/notifications">
                            <Badge color="primary" variant="dot"><IoIosNotificationsOutline/> </Badge><i></i> Notifications</a></li>
                        <li><a href="/leaderboard"><MdOutlineLeaderboard/><i></i> Leaderboard</a></li>
                        <li><a href="/campaigns"><BiWorld/><i></i> Campaigns</a></li>
                        <li><a href="/all-coders"><RiTeamLine/><i></i> All Coders</a></li>
                        <li>
                            <div className="dropdown">
                                <button className="dropbtn"><BiUserCircle  size = '30px' /></button>
                                <div className="dropdown-content">
                                    <a href="/profile"><RxPerson /><i></i> Profile</a>
                                    <a href="/welcome" onClick={handleLogout}><FiLogOut /><i></i> Log Out</a>
                                </div>
                            </div>
                            
                        </li>
                    </ul>
                </div>
                <div id="shrinkScreen" onClick={this.handleClick}>
                    <i id="bar"
                        className={this.state.clicked ? 
                        "fas fa-times" :
                        "fas fa-bars"}
                    ></i>
                </div>
            </nav>       
        );
    }
}

export default Navbar;